
import { defineComponent } from 'vue'
import SiteHeader from '@/components/SiteHeader.vue' // @ is an alias to /src

export default defineComponent({
  name: 'App',
  components: {
    SiteHeader
  }
})
